import { signInAnonymously } from 'firebase/auth';
import { auth } from '../firebase';

// Returns the current visitor's Firebase Auth UID, signing them in
// anonymously (silently, no form) if they don't have one yet. Firebase
// persists this in the browser automatically, so a returning visitor
// keeps the same UID across refreshes without this re-creating a new one.
export async function ensureVisitorUid() {
  if (auth.currentUser) return auth.currentUser.uid;
  const result = await signInAnonymously(auth);
  return result.user.uid;
}